import { https } from './https';
import { api_url } from './../Configuration/config';

//get PromotedVideos
export async function getPromotedVideos(filter){
    return await https.get(`${api_url}admin/promotes?${filter}`);
}